import { noop } from "lodash-es"
import { createContext, useContext } from "react"
import { AvatarUploaderContextProps } from "./types"

export const AvatarUploaderContext = createContext<AvatarUploaderContextProps>({
  file: null,
  setFile: noop,
  onUpload: noop,
  onRemove: noop,
  mimeTypes: "image/jpeg,image/jpg,image/png",
})

export const useAvatarUploaderContext = () => {
  const contextData = useContext(AvatarUploaderContext)

  if (!contextData) {
    throw new Error("The provider for AvatarUploaderContext is missing!")
  }

  return contextData
}
